// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6132":"css/app.7087","8499":"css/admin-app.7087"}[chunkId] + ".css";
};